module.exports = __webpack_public_path__ + "img/lambus_pro_logo.f885c30.png";